import Super from './base.gjs';

export default class SpdsLayoutFlexColumn extends Super {
  column = true;
  variantClass = 'spds-layout-flex-column';
}
